import React, { useRef, useState } from "react";
import { DropdownMenu } from "../../components/Dropdown/Dropdown";
import SortFieldsButton from "./SortFieldsButton";
import DropdownPortal from "src/app/components/DropdownPortal";

import "./SortFieldsDropdown.scss";

function SortFieldsDropdown({ sortBy, dropdownMenuItems, stickToBottom }) {
  const [visible, setVisible] = useState(false);
  const triggerRef = useRef(null);

  const closeDropdown = () => setVisible(false);

  return (
    <DropdownPortal
      className="sort-fields-dropdown"
      overlay={
        <DropdownMenu
          className="sort-fields-dropdown__menu"
          isOpen={visible}
          stickToBottom={stickToBottom}
          triggerRef={triggerRef}
        >
          {dropdownMenuItems(closeDropdown)}
        </DropdownMenu>
      }
      visible={visible}
      onVisibleChange={(v) => setVisible(v)}
    >
      <span
        ref={triggerRef}
        className="sort-fields-dropdown__button"
        data-qa="sort-button"
      >
        <SortFieldsButton activeSortingColumnName={sortBy} />
      </span>
    </DropdownPortal>
  );
}

export default SortFieldsDropdown;
